import React from "react";
import styled from "styled-components";
import { IconProps } from "@xsolla/xui-primitives-core";
import { createFilteredElement } from "./filterDOMProps";

const FilteredDiv = createFilteredElement("div");

const StyledIcon = styled(FilteredDiv)<IconProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${(props) =>
    typeof props.size === "number" ? `${props.size}px` : props.size || "24px"};
  height: ${(props) =>
    typeof props.size === "number" ? `${props.size}px` : props.size || "24px"};
  color: ${(props) => props.color || "currentColor"};

  /* Icons paint themselves — each icon's own SVG sets its fill/stroke
     (icons-base via inline "fill: currentColor", Lucide via "fill"/"stroke"
     attributes). Do not add fill/stroke here: it re-strokes fill-based icons
     and thickens the glyph. See FEP-877. */
  svg {
    width: 100%;
    height: 100%;
  }
`;

export const Icon: React.FC<IconProps> = ({
  children,
  testID,
  "data-testid": dataTestId,
  ...props
}) => {
  return (
    <StyledIcon data-testid={dataTestId || testID} {...props}>
      {children}
    </StyledIcon>
  );
};
